import styledComponents from 'styled-components'

export const Text = styledComponents.span``

export const DetailedText = Text.extend`
  font-size: 12px;
`
